import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { useEmbedStore } from '@/stores/embedStore'
import { isEmbedded } from '@/lib/embed'
import { canAccessPortal } from '@/api/types'
import EmbedNotice from '@/components/EmbedNotice'

export default function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.role)
  const denyAccess = useAuthStore((s) => s.denyAccess)
  const embedStatus = useEmbedStore((s) => s.status)
  // Catches sessions that never went through the login form's check: a stored session,
  // a refresh that changed the role, or a token handed over by an embedding partner.
  const forbidden = isAuthenticated && !canAccessPortal(role)

  useEffect(() => {
    if (forbidden && !isEmbedded()) denyAccess()
  }, [forbidden, denyAccess])

  // Embedded: render only once the parent's handshake (session + CSS) has landed,
  // so partner-hidden parts never flash. Never redirect a frame to the login form.
  if (isEmbedded()) {
    if (forbidden) return <EmbedNotice state="forbidden" />
    if (embedStatus === 'ready' && isAuthenticated) return <Outlet />
    return <EmbedNotice state={embedStatus === 'connecting' ? 'connecting' : 'failed'} />
  }

  if (forbidden) return null
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
}
